import React from 'react';
import PropTypes from 'prop-types';

import 'bloko/blocks/section/section.less';

/**
 * Блок связанного контента. Задает нижний отступ.
 */
export default function Section({ children, ...sectionProps }) {
    return (
        <div className="bloko-section" {...sectionProps}>
            {children}
        </div>
    );
}

Section.propTypes = {
    /** Содержимое внутри bloko-section */
    children: PropTypes.node,
};
